import React from "react";
import {
  Grid,
  Typography,
  FormControlLabel,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles, { CustomRadio } from "../../styles";

export default function RowWhoPaysQuotas({
  whoPaysQuotas,
  handleChange,
}: {
  whoPaysQuotas: string;
  handleChange(e: string): void;
}): JSX.Element {
  const { secondColumn } = useStyles();

  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.who-pays-the-quotas")}:
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <FormControl component="fieldset">
          <RadioGroup
            name="who-pays-the-quotas"
            value={whoPaysQuotas}
            onChange={(e) => handleChange(e.target.value)}
          >
            <Grid item container xs={12} alignItems="center">
              <FormControlLabel
                value="employee"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.the-employee")}
                  </Typography>
                }
              />
              <FormControlLabel
                value="company"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.the-company")}
                  </Typography>
                }
              />
              <FormControlLabel
                value="both"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.both-of-them")}
                  </Typography>
                }
              />
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
}
